import { setLocale } from 'yup';

// Centralized Polish defaults for Yup validation messages.
// Imported once for its side effect (see src/index.tsx) so every form falls back
// to Polish when a field has no explicit message. Explicit per-field messages
// passed to a validator still take precedence over these defaults.
setLocale({
  mixed: {
    default: 'Nieprawidłowa wartość',
    required: 'To pole jest wymagane',
    notType: 'Nieprawidłowa wartość',
  },
  string: {
    email: 'Wpisz poprawny adres email',
    min: ({ min }) => `Minimalna liczba znaków: ${min}`,
    max: ({ max }) => `Maksymalna liczba znaków: ${max}`,
    matches: 'Nieprawidłowy format',
  },
  number: {
    min: ({ min }) => `Wartość musi być większa lub równa ${min}`,
    max: ({ max }) => `Wartość musi być mniejsza lub równa ${max}`,
  },
});
